import { Outlet, useLocation } from "react-router-dom";
import React, { useEffect } from "react";
import { Layout ,Skeleton} from "antd";
import Nav from "../components/NavNew";
const { Header, Content, Footer } = Layout;

const MainLayout = () => {

  const location = useLocation(); // 获取当前的路由位置
  return (
    <div className="">
      <Layout className="bg-transparent">
      {location.pathname !== '/summary' && <Header className="w-full p-0 h-[95px]  px-[50px] bg-transparent card_primary_bg_black">
          <Nav />
        </Header>}
        <Content className="mx-auto w-full flex flex-col justify-center items-center overflow-y-auto">
           <Outlet /> 

        </Content>
        {/* <Footer className="">
          <div className=""></div>
        </Footer> */}
        {/* <FloatingBlock /> */}
      </Layout>
    </div>
  );
};
export default MainLayout;
